export default __webpack_public_path__ + "b2669f12b4c5b87d565dae545c1cab9e.jpg";